// adds a leading slash to the beginning of a string (presumably as a path in a url)
// if it doesn't have one already

export function getPathWithLeadingSlash(path: string) {
  return path[0] === '/' ? path : `/${path}`;
}

/**
 * Builds a tenant-scoped path. Returns `'/'` when `tenantId` is falsy so that
 * callers never produce `/tenants/undefined/…` URLs.
 */
export const buildTenantPath = (
  tenantId: string | undefined,
  subpath: string = '/',
): string =>
  tenantId ? `/tenants/${tenantId}${getPathWithLeadingSlash(subpath)}` : '/';
